import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const DEOVisitWorkflow = () => {
  const { visitId } = useParams();
  const [citizenId, setCitizenId] = useState(null);

  useEffect(() => {
    const fetchVisit = async () => {
      try {
        const response = await axios.get(`/api/visits/${visitId}`);
        const visit = response.data?.visit;

        if (visit?.citizenId) {
          setCitizenId(visit.citizenId);
        } else {
          console.warn('Citizen ID not found in visit response.');
        }
      } catch (error) {
        console.error('Error fetching visit:', error);
      }
    };

    fetchVisit();
  }, [visitId]);

  return (
    <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Left: OPD Slip Preview */}
      <div className="bg-white shadow-md rounded p-4">
        <h2 className="text-lg font-semibold mb-2">Uploaded OPD Slip</h2>
        <img
          src={`/api/visit/${visitId}/slip`}
          alt="OPD Slip Preview"
          className="w-full h-auto border"
        />
      </div>

      {/* Right: Structured Entry Navigation */}
      <div className="bg-green-50 shadow-md rounded p-4">
        <h2 className="text-lg font-semibold mb-2">Structured Entry (DEO)</h2>
        {citizenId ? (
          <div className="space-y-2">
            <Link to={`/citizen/${citizenId}/medical-history`} className="block text-blue-600 underline">Medical History</Link>
            <Link to={`/citizen/${citizenId}/examination`} className="block text-blue-600 underline">Clinical Examination</Link>
            <Link to={`/citizen/${citizenId}/investigations`} className="block text-blue-600 underline">Investigations</Link>
            <Link to={`/citizen/${citizenId}/prescriptions`} className="block text-blue-600 underline">Prescription</Link>
          </div>
        ) : (
          <p className="text-gray-500">Loading citizen data...</p>
        )}
      </div>
    </div>
  );
};

export default DEOVisitWorkflow;
